<!-- BODY LAYOUT -->
<template>
  <!-- Centers and horizontally pads the content. Use fluid to fully extend the container -->
  <v-container>
    <v-row text-center wrap>
      <v-col sm="12" class="text-center">
        <h2 class="title primary--text">Welcome to Bill Tracker</h2>

        <!-- <p class="subtitle-1 accent--text"
          >Below are some useful links to help you use the shell project.</p
        > -->
      </v-col>
      <v-col sm="12">
        <v-img
          :src="require('@assets/ETS-Logo-Header.png')"
          contain
          height="180"
        ></v-img>
      </v-col>
      <!-- <v-col align="center" xs="auto" mb-4> -->
      <!-- UNPWSignIn Component. The code is in components/login/unpw-signin.vue. To use it, it has to be imported within the script and than define the component name in a components instance. See in the script below -->
      <!-- <UNPWSignIn></UNPWSignIn>
        </v-col> -->
    </v-row>
    <v-col align="center" xs="auto" mb-4>
      <!-- GoogleSignin Component. The code is in components/login/google-signin.vue. To use it, it has to be imported within the script and than define the component name in a components instance. See in the script below -->
      <span v-show="!isLoggedIn && singleProvider == 'google'"
        ><GoogleSignin></GoogleSignin>
      </span>
    </v-col>
  </v-container>
</template>

<!-- SCRIPTS -->
<script>
import GoogleSignin from '@components/login/google-signin'
import { authComputed } from '@state/helpers'
import appConfig from '@src/app.config'
export default {
  page: {
    title: 'Log in',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  // COMPONENT INSTANCE
  components: {
    GoogleSignin,
  },
  data: () => ({}),
  computed: {
    ...authComputed,
  },
}
</script>

<!-- STYLES -->
<style></style>
